import SharedAnchor from 'components/pages/@shared/mdx/anchor'
import SharedInlineCode from 'components/pages/@shared/mdx/inline-code'

const CodeAnchor = ({ href, children }) => {
  return (
    <SharedAnchor href={href}>
      <SharedInlineCode
        css={{
          textDecoration: 'underline',
          color: '$primary',
        }}
      >
        {children}
      </SharedInlineCode>
    </SharedAnchor>
  )
}

export default CodeAnchor
